import Locale from 'rmc-calendar/es/locale/zh_CN';
export default Locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/calendar/locale/zh_CN.js
// module id = 298
// module chunks = 0